export const footerMoreLinks = {
  'tj-ru': [
    {
      title: 'Больше',
      items: [
        {
          href: 'https://tj.wingie.com/contact/',
          title: 'Контакты',
        },
        {
          href: 'https://tj.wingie.com/faq/',
          title: 'Часто задаваемые вопросы',
        },

        {
          href: 'https://tj.wingie.com/about-us/',
          title: 'О нас',
        },
        {
          href: 'https://tj.wingie.com/privacy/',
          title: 'Конфиденциальность',
        },
        {
          href: 'https://tj.wingie.com/terms-and-conditions/',
          title: 'Условия и положения',
        },
        {
          href: 'https://tj.wingie.com/awards/',
          title: 'Наши награды',
        },
      ],
    },
  ],
  'tj-en': [
    {
      title: 'More',
      items: [
        {
          href: 'https://tj.wingie.com/en/contact/',
          title: 'Contact',
        },
        {
          href: 'https://tj.wingie.com/en/faq/',
          title: 'Frequently Asked Questions',
        },

        {
          href: 'https://tj.wingie.com/en/about-us/',
          title: 'About us',
        },
        {
          href: 'https://tj.wingie.com/en/privacy/',
          title: 'Privacy',
        },
        {
          href: 'https://tj.wingie.com/en/terms-and-conditions/',
          title: 'Terms and Conditions',
        },
        {
          href: 'https://tj.wingie.com/en/awards/',
          title: 'Our Awards',
        },
      ],
    },
  ],
  'tj-es': [
    {
      title: 'Más',
      items: [
        {
          href: 'https://tj.wingie.com/es/contacto/',
          title: 'Contacto',
        },
        {
          href: 'https://tj.wingie.com/es/preguntas-frecuentes/',
          title: 'Preguntas más frecuentes',
        },

        {
          href: 'https://tj.wingie.com/es/acerca-de-nosotros/',
          title: 'Sobre nosotros',
        },
        {
          href: 'https://tj.wingie.com/es/privacidad/',
          title: 'Privacidad',
        },
        {
          href: 'https://tj.wingie.com/es/terminos-y-condiciones/',
          title: 'Términos y condiciones de uso',
        },
        {
          href: 'https://tj.wingie.com/es/awards/',
          title: 'Nuestras premios',
        },
      ],
    },
  ],
  'tj-de': [
    {
      title: 'Mehr',
      items: [
        {
          href: 'https://tj.wingie.com/de/kontakt/',
          title: 'Kontakt',
        },
        {
          href: 'https://tj.wingie.com/de/faq/',
          title: 'Häufig gestellte Fragen',
        },

        {
          href: 'https://tj.wingie.com/de/uber-uns/',
          title: 'Über uns',
        },
        {
          href: 'https://tj.wingie.com/de/datenschutz/',
          title: 'Datenschutz',
        },
        {
          href: 'https://tj.wingie.com/de/allgemeine-geschaftsbedingungen/',
          title: 'Allgemeine Geschäftsbedingungen',
        },
        {
          href: 'https://tj.wingie.com/de/awards/',
          title: 'Unsere Preise',
        },
      ],
    },
  ],
  'tj-ar': [
    {
      title: 'المزيد',
      items: [
        {
          href: 'https://tj.wingie.com/ar/contact/',
          title: 'اتصل بنا',
        },
        {
          href: 'https://tj.wingie.com/ar/faq/',
          title: 'الأسئلة الشائعة',
        },

        {
          href: 'https://tj.wingie.com/ar/about-us/',
          title: 'من نحن',
        },
        {
          href: 'https://tj.wingie.com/ar/privacy/',
          title: 'الخصوصية',
        },
        {
          href: 'https://tj.wingie.com/ar/terms-and-conditions/',
          title: 'الشروط والأحكام',
        },
        {
          href: 'https://tj.wingie.com/ar/awards/',
          title: 'جوائزنا',
        },
      ],
    },
  ],
  'tj-it': [
    {
      title: 'Di più',
      items: [
        { href: 'https://tj.wingie.com/it/contact/', title: 'Contatto' },
        // { href: 'https://tj.wingie.com/it/faq/', title: 'Domande frequenti' },

        { href: 'https://tj.wingie.com/it/about-us/', title: 'Chi siamo' },
        { href: 'https://tj.wingie.com/it/privacy/', title: 'Privacy' },
        { href: 'https://tj.wingie.com/it/terms-and-conditions/', title: 'Termini e condizioni' },
        { href: 'https://tj.wingie.com/it/awards/', title: 'I nostri premi' },
      ],
    },
  ],
  'tj-fr': [
    {
      title: 'Plus',
      items: [
        { href: 'https://tj.wingie.com/fr/contact/', title: 'Contact' },
        // { href: 'https://tj.wingie.com/fr/faq/', title: 'Questions fréquemment posées' },

        { href: 'https://tj.wingie.com/fr/about-us/', title: 'À propos de nous' },
        { href: 'https://tj.wingie.com/fr/privacy/', title: 'Confidentialité' },
        { href: 'https://tj.wingie.com/fr/terms-and-conditions/', title: 'Conditions générales' },
        { href: 'https://tj.wingie.com/fr/awards/', title: 'Nos prix' },
      ],
    },
  ],
  'tj-pt': [
    {
      title: 'Mais',
      items: [
        { href: 'https://tj.wingie.com/pt/contact/', title: 'Contato' },
        // { href: 'https://tj.wingie.com/pt/faq/', title: 'Perguntas frequentes' },

        { href: 'https://tj.wingie.com/pt/about-us/', title: 'Sobre nós' },
        { href: 'https://tj.wingie.com/pt/privacy/', title: 'Privacidade' },
        { href: 'https://tj.wingie.com/pt/terms-and-conditions/', title: 'Termos e condições' },
        { href: 'https://tj.wingie.com/pt/awards/', title: 'Nossos prêmios' },
      ],
    },
  ],
  'tj-ro': [
    {
      title: 'Mai mult',
      items: [
        { href: 'https://tj.wingie.com/ro/contact/', title: 'Contact' },
        // { href: 'https://tj.wingie.com/ro/faq/', title: 'Întrebări frecvente' },

        { href: 'https://tj.wingie.com/ro/about-us/', title: 'Despre noi' },
        { href: 'https://tj.wingie.com/ro/privacy/', title: 'Confidențialitate' },
        { href: 'https://tj.wingie.com/ro/terms-and-conditions/', title: 'Termeni și condiții' },
        { href: 'https://tj.wingie.com/ro/awards/', title: 'Premii noastre' },
      ],
    },
  ],
  'tj-pl': [
    {
      title: 'Więcej',
      items: [
        { href: 'https://tj.wingie.com/pl/contact/', title: 'Kontakt' },
        // { href: 'https://tj.wingie.com/pl/faq/', title: 'Często zadawane pytania' },

        { href: 'https://tj.wingie.com/pl/about-us/', title: 'O nas' },
        { href: 'https://tj.wingie.com/pl/privacy/', title: 'Prywatność' },
        { href: 'https://tj.wingie.com/pl/terms-and-conditions/', title: 'Regulamin' },
        { href: 'https://tj.wingie.com/pl/awards/', title: 'Nasze nagrody' },
      ],
    },
  ],
  'tj-lt': [
    {
      title: 'Daugiau',
      items: [
        { href: 'https://tj.wingie.com/lt/contact/', title: 'Kontaktai' },
        // { href: 'https://tj.wingie.com/lt/faq/', title: 'Dažniausiai užduodami klausimai' },

        { href: 'https://tj.wingie.com/lt/about-us/', title: 'Apie mus' },
        { href: 'https://tj.wingie.com/lt/privacy/', title: 'Privatumas' },
        { href: 'https://tj.wingie.com/lt/terms-and-conditions/', title: 'Naudojimo sąlygos' },
        { href: 'https://tj.wingie.com/lt/awards/', title: 'Mūsų premijos' },
      ],
    },
  ],
  'tj-uz': [
    {
      title: 'Boshqa',
      items: [
        { href: 'https://tj.wingie.com/uz/contact/', title: 'Aloqa' },
        // { href: 'https://tj.wingie.com/uz/faq/', title: "Tez-tez so'raladigan savollar" },

        { href: 'https://tj.wingie.com/uz/about-us/', title: 'Biz haqimizda' },
        { href: 'https://tj.wingie.com/uz/privacy/', title: 'Maxfiylik' },
        { href: 'https://tj.wingie.com/uz/terms-and-conditions/', title: 'Shartlar va qoidalar' },
        { href: 'https://tj.wingie.com/uz/awards/', title: 'Bizning mukofotlarimiz' },
      ],
    },
  ],
  'tj-sr': [
    {
      title: 'Više',
      items: [
        { href: 'https://tj.wingie.com/sr/contact/', title: 'Kontakt' },
        // { href: 'https://tj.wingie.com/sr/faq/', title: 'Često postavljana pitanja' },

        { href: 'https://tj.wingie.com/sr/about-us/', title: 'O nama' },
        { href: 'https://tj.wingie.com/sr/privacy/', title: 'Privatnost' },
        { href: 'https://tj.wingie.com/sr/terms-and-conditions/', title: 'Uslovi korišćenja' },
        { href: 'https://tj.wingie.com/sr/awards/', title: 'Naše nagrade' },
      ],
    },
  ],
  'tj-ky': [
    {
      title: 'Дагы',
      items: [
        { href: 'https://tj.wingie.com/ky/contact/', title: 'Байланыш' },
        // { href: 'https://tj.wingie.com/ky/faq/', title: 'Көп берилүүчү суроолор' },

        { href: 'https://tj.wingie.com/ky/about-us/', title: 'Биз жөнүндө' },
        { href: 'https://tj.wingie.com/ky/privacy/', title: 'Купуялык' },
        { href: 'https://tj.wingie.com/ky/terms-and-conditions/', title: 'Шарттар жана эрежелер' },
        { href: 'https://tj.wingie.com/ky/awards/', title: 'Биздин марапаттарымыз' },
      ],
    },
  ],
  'tj-tg': [
    {
      title: 'Бештар',
      items: [
        { href: 'https://tj.wingie.com/tg/contact/', title: 'Тамос' },
        // { href: 'https://tj.wingie.com/tg/faq/', title: 'Саволҳои зиёд пурсидашаванда' },

        { href: 'https://tj.wingie.com/tg/about-us/', title: 'Дар бораи мо' },
        { href: 'https://tj.wingie.com/tg/privacy/', title: 'Махфият' },
        { href: 'https://tj.wingie.com/tg/terms-and-conditions/', title: 'Шартҳо ва қоидаҳо' },
        { href: 'https://tj.wingie.com/tg/awards/', title: 'Биздин марапаттарымыз' },
      ],
    },
  ],
  'tj-kk': [
    {
      title: 'Көбірек',
      items: [
        { href: 'https://tj.wingie.com/kk/contact/', title: 'Байланыс' },
        // { href: 'https://tj.wingie.com/kk/faq/', title: 'Жиі қойылатын сұрақтар' },

        { href: 'https://tj.wingie.com/kk/about-us/', title: 'Біз туралы' },
        { href: 'https://tj.wingie.com/kk/privacy/', title: 'Құпиялылық' },
        { href: 'https://tj.wingie.com/kk/terms-and-conditions/', title: 'Шарттар мен ережелер' },
        { href: 'https://tj.wingie.com/kk/awards/', title: 'Біздің марапаттарымыз' },
      ],
    },
  ],
  'tj-nl': [
    {
      title: 'Meer',
      items: [
        { href: 'https://tj.wingie.com/nl/contact/', title: 'Contact' },
        // { href: 'https://tj.wingie.com/nl/faq/', title: 'Veelgestelde vragen' },

        { href: 'https://tj.wingie.com/nl/about-us/', title: 'Over ons' },
        { href: 'https://tj.wingie.com/nl/privacy/', title: 'Privacy' },
        { href: 'https://tj.wingie.com/nl/terms-and-conditions/', title: 'Voorwaarden' },
        { href: 'https://tj.wingie.com/nl/awards/', title: 'Onze prijzen' },
      ],
    },
  ],
  'tj-ja': [
    {
      title: 'もっと',
      items: [
        { title: 'お問い合わせ', href: 'https://tj.wingie.com/ja/contact/' },
        { title: 'よくある質問', href: 'https://tj.wingie.com/en/faq/' },
        { title: '会社概要', href: 'https://tj.wingie.com/ja/about-us/' },
        { title: 'プライバシーポリシー', href: 'https://tj.wingie.com/ja/privacy/' },
        { title: '利用規約', href: 'https://tj.wingie.com/ja/terms-and-conditions/' },
        { title: '受賞歴', href: 'https://tj.wingie.com/ja/awards/' },
      ],
    },
  ],
  'tj-zh': [
    {
      title: '更多',
      items: [
        { title: '联系方式', href: 'https://tj.wingie.com/zh/contact/' },
        { title: '常见问题', href: 'https://tj.wingie.com/en/faq/' },
        { title: '关于我们', href: 'https://tj.wingie.com/zh/about-us/' },
        { title: '隐私政策', href: 'https://tj.wingie.com/zh/privacy/' },
        { title: '条款和条件', href: 'https://tj.wingie.com/zh/terms-and-conditions/' },
        { title: '我们的奖项', href: 'https://tj.wingie.com/zh/awards/' },
      ],
    },
  ],
  'tj-ko': [
    {
      title: '더보기',
      items: [
        { title: '연락처', href: 'https://tj.wingie.com/ko/contact/' },
        { title: '자주 묻는 질문', href: 'https://tj.wingie.com/en/faq/' },
        { title: '회사 소개', href: 'https://tj.wingie.com/ko/about-us/' },
        { title: '개인정보처리방침', href: 'https://tj.wingie.com/ko/privacy/' },
        { title: '이용약관', href: 'https://tj.wingie.com/ko/terms-and-conditions/' },
        { title: '수상 내역', href: 'https://tj.wingie.com/ko/awards/' },
      ],
    },
  ],
  'tj-hi': [
    {
      title: 'अधिक',
      items: [
        { title: 'संपर्क करें', href: 'https://tj.wingie.com/hi/contact/' },
        { title: 'सामान्य प्रश्न', href: 'https://tj.wingie.com/en/faq/' },
        { title: 'हमारे बारे में', href: 'https://tj.wingie.com/hi/about-us/' },
        { title: 'गोपनीयता', href: 'https://tj.wingie.com/hi/privacy/' },
        { title: 'नियम और शर्तें', href: 'https://tj.wingie.com/hi/terms-and-conditions/' },
        { title: 'हमारे पुरस्कार', href: 'https://tj.wingie.com/hi/awards/' },
      ],
    },
  ],
  'tj-ta': [
    {
      title: 'மேலும்',
      items: [
        { title: 'தொடர்பு', href: 'https://tj.wingie.com/ta/contact/' },
        { title: 'அடிக்கடி கேட்கப்படும் கேள்விகள்', href: 'https://tj.wingie.com/en/faq/' },
        { title: 'எங்கள் பற்றி', href: 'https://tj.wingie.com/ta/about-us/' },
        { title: 'தனியுரிமை', href: 'https://tj.wingie.com/ta/privacy/' },
        { title: 'விதிமுறைகள்', href: 'https://tj.wingie.com/ta/terms-and-conditions/' },
        { title: 'எங்கள் விருதுகள்', href: 'https://tj.wingie.com/ta/awards/' },
      ],
    },
  ],
  'tj-th': [
    {
      title: 'เพิ่มเติม',
      items: [
        { title: 'ติดต่อเรา', href: 'https://tj.wingie.com/th/contact/' },
        { title: 'คำถามที่พบบ่อย', href: 'https://tj.wingie.com/en/faq/' },
        { title: 'เกี่ยวกับเรา', href: 'https://tj.wingie.com/th/about-us/' },
        { title: 'นโยบายความเป็นส่วนตัว', href: 'https://tj.wingie.com/th/privacy/' },
        { title: 'ข้อกำหนดและเงื่อนไข', href: 'https://tj.wingie.com/th/terms-and-conditions/' },
        { title: 'รางวัลของเรา', href: 'https://tj.wingie.com/th/awards/' },
      ],
    },
  ],
  'tj-ur': [
    {
      title: 'مزید',
      items: [
        { title: 'رابطہ کریں', href: 'https://tj.wingie.com/ur/contact/' },
        { title: 'عمومی سوالات', href: 'https://tj.wingie.com/en/faq/' },
        { title: 'ہمارے بارے میں', href: 'https://tj.wingie.com/ur/about-us/' },
        { title: 'رازداری', href: 'https://tj.wingie.com/ur/privacy/' },
        { title: 'شرائط و ضوابط', href: 'https://tj.wingie.com/ur/terms-and-conditions/' },
        { title: 'ہمارے اعزازات', href: 'https://tj.wingie.com/ur/awards/' },
      ],
    },
  ],
  'tj-ka': [
    {
      title: 'მეტი',
      items: [
        { title: 'კონტაქტი', href: 'https://tj.wingie.com/ka/contact/' },
        { title: 'ხშირად დასმული კითხვები', href: 'https://tj.wingie.com/en/faq/' },
        { title: 'ჩვენ შესახებ', href: 'https://tj.wingie.com/ka/about-us/' },
        { title: 'კონფიდენციალურობა', href: 'https://tj.wingie.com/ka/privacy/' },
        { title: 'წესები და პირობები', href: 'https://tj.wingie.com/ka/terms-and-conditions/' },
        { title: 'ჩვენი ჯილდოები', href: 'https://tj.wingie.com/ka/awards/' },
      ],
    },
  ],
}
